<template>
    <div class="order_item">
        <div class="order_news">
            <div class="order-top-left">
                <slot name="order_date"></slot>
                <slot name="order_num"></slot>
                <slot name="order_type"></slot>
            </div>
        </div>
        <div class="order_item_news">
            <div class="order_item_img">
                <slot name="userImg"></slot>
                <slot name="ksImg"></slot>
            </div>
            <slot name="order_course_name"></slot>
            <slot name="order_pay_num"></slot>
            <slot name="user_name"></slot>
            <slot name="order_price"></slot>
            <div class="order_type_box">
                <p :class="orderStatus">
                    <slot name="order_type_p"></slot>
                </p>
                <div @click="enterDetails">订单详情</div>
                <div v-if="orderType === '3' && invoiceInfo.id" @click="enterInvoice" >
                    查看发票详情
                </div>
            </div>
        </div>
        <personal-invoice-info
            :invoiceVisible="invoiceVisible"
            :invoiceInfo="invoiceInfo"
            :remoteInvoiceClose="remoteInvoiceClose"
        ></personal-invoice-info>
    </div>
</template>
<script>
import PersonalInvoiceInfo from "@/components/common/personalInvoiceInfo/PersonalInvoiceInfo";

export default {
    name: "OrderItem",
    components: { PersonalInvoiceInfo },
    props: {
        //订单状态 "0"待支付 "1" 已取消 "2" 交易关闭 "3" 已完成
        orderType: {
            type: String,
            default: "",
        },
        //订单类型 "0" 培训报名
        businessType: {
            type: String,
            default: "",
        },
        //订单ID
        orderID: {
            type: String,
            default: "",
        },
        //发票信息信息
        invoiceInfo: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        //订单状态类名
        orderStatus() {
            let className = "";
            if (this.orderType == "0") {
                className = "warning";
            } else if (this.orderType == "1") {
                className = "danger";
            } else if (this.orderType == "2") {
                className = "";
            } else if (this.orderType == "3") {
                className = "success";
            }
            return className;
        },
    },
    data() {
        return {
            invoiceVisible:false,//发票dialog flage
        };
    },
    created(){
    },
    methods: {
        //进入订单详情
        enterDetails() {
            this.$router.push({
                path: "/pcViews/order-details",
                query: { orderId: this.orderID },
            });
        },
        //打开发票信息窗口
        enterInvoice() {
            this.invoiceVisible = true;
        },
        //关闭发票窗口
        remoteInvoiceClose() {
            this.invoiceVisible = false;
        },
    },
};
</script>
<style scoped>
.order_type_box p.warning {
    color: #b21f27;
}
.order_type_box p.danger {
    color: #ff8e09;
}
.order_type_box p.success {
    color: #1fb226;
}
.order_type_box div {
    color: #818181;
    font-size: 14px;
    line-height: 16px;
    border-bottom: solid 1px #3b3b3b;
    cursor: pointer;
    margin-bottom: 10px;
}
.order_type_box p {
    line-height: 42px;
}
.order_type_box {
    font-size: 14px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-left: solid 1px #e6e6e6;
}
.order_price {
    margin: 0 42px;
    font-size: 14px;
}
.user_name {
    display: flex;
    align-items: center;
    margin-left: 36px;
    padding: 0 16px;
    height: 100%;
    color: #3b3b3b;
    font-size: 14px;
    border-left: solid 1px #e6e6e6;
    border-right: solid 1px #e6e6e6;
}
.order_pay_num {
    font-size: 14px;
    color: #818181;
}
.order_course_name p {
    line-height: 26px;
    font-size: 14px;
    color: #3b3b3b;
}
.order_course_name {
    margin: 16px;
    flex: 1;
}
.order_item_img img {
    width: 100%;
    height: 100%;
}
.order_item_img {
    height: 108px;
    width: 160px;
    border: solid 1px #e6e6e6;
    position: relative;
    display: flex;
}
.order_item_img span {
    width: 100%;
    height: 100%;
    z-index: 100;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #fff;
}
.order_item_news {
    padding: 0 16px;
    height: 134px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.order_num {
    margin-right: 70px;
}
.order_date {
    margin-right: 60px;
}
.order_news span {
    color: #000;
}
.order-top-left {
    display: flex;
    flex-direction: row;
}
.order_cancel {
    font-size: 16px;
    color: #3b3b3b;
    cursor: pointer;
    border-bottom: solid 1px #3b3b3b;
}
.order_news {
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #9e9e9e;
    height: 30px;
    background: #f5f5f5;
}
.order_item {
    margin: 10px 0;
    border: solid 1px #e2e2e2;
}
</style>
